import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=483216e4&scoped=true&"
import script from "./Input.vue?vue&type=script&lang=ts&"
export * from "./Input.vue?vue&type=script&lang=ts&"
import style0 from "./Input.vue?vue&type=style&index=0&id=483216e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483216e4",
  null
  
)

export default component.exports